var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7643 14.7316L111.45 21.9223V158.546L47.7643 151.355V14.7316Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.9223L47.7644 14.7316V151.355L0 158.546V21.9223Z",
    fill: "#BDC3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.45 21.9223L159.214 14.7316V151.355L111.45 158.546V21.9223Z",
    fill: "#BDC3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96057 29.113L47.7642 21.9222V144.164L7.96057 151.355V29.113Z",
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7643 21.9222L111.45 29.113V151.355L47.7643 144.164V21.9222Z",
    fill: "#2ECC71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.568 7.5408C74.3771 7.5408 63.6859 17.1994 63.6859 29.113C63.6859 41.0265 74.3771 50.6851 87.568 50.6851C100.759 50.6851 111.45 41.0265 111.45 29.113C111.45 17.1994 100.759 7.5408 87.568 7.5408ZM87.568 21.9222C91.9624 21.9222 95.5288 25.1415 95.5288 29.113C95.5288 33.0844 91.9624 36.3037 87.568 36.3037C83.1737 36.3037 79.6073 33.0844 79.6073 29.113C79.6073 25.1415 83.1737 21.9222 87.568 21.9222Z",
    fill: "#C0392B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.254 144.164L111.45 151.355V29.113L151.254 21.9222V144.164Z",
    fill: "#27AE60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3551 24.7987L10.9459 28.3941L47.7643 63.6279V42.7755L29.3551 24.7987Z",
    fill: "#F39C12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.254 129.783L111.45 136.974V93.8294L151.254 72.2573V129.783Z",
    fill: "#F39C12"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M151.254 144.164L111.45 151.355V108.211L151.254 86.6387V144.164Z",
    fill: "#2980B9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7643 101.02L111.45 93.8294V136.974L47.7643 129.783V101.02Z",
    fill: "#F1C40F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7643 115.402L111.45 108.211V151.355L47.7643 144.164V115.402Z",
    fill: "#3498DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96057 122.592L47.7642 101.02V129.783L7.96057 136.974V122.592Z",
    fill: "#F39C12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96057 136.974L47.7642 115.402V144.164L7.96057 151.355V136.974Z",
    fill: "#2980B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7643 63.6336V42.7913L79.6072 105.061H67.9129L47.7643 63.6336Z",
    fill: "#F1C40F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5681 0.350113C69.9828 0.350113 55.7252 13.2934 55.7252 29.113C55.7252 34.1465 57.2441 38.4611 59.8297 42.7755C60.2588 43.4946 60.7094 44.2131 61.1982 44.9322L87.5681 86.6387L113.934 44.9322C114.34 44.2131 114.69 43.4944 115.056 43.4944L115.303 42.7755C117.89 38.4611 119.411 34.1465 119.411 29.113C119.411 13.2934 105.153 0.350113 87.5681 0.350113ZM87.5681 14.7315C96.3647 14.7315 103.49 21.2032 103.49 29.113C103.49 37.0228 96.3647 43.4944 87.5681 43.4944C78.7715 43.4944 71.6466 37.0228 71.6466 29.113C71.6466 21.2032 78.7715 14.7315 87.5681 14.7315Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.84954dfea3136e2a19c0313a539a0ebf.svg";
export { ForwardRef as ReactComponent };